import React, { forwardRef } from 'react';
import { Typography } from '..';
import IconComponent from '../../Icon';

export const inputTypes = {
    search: 'search',
};

const InputMessage = ({ error, message }) => {
    return (
        <Typography variant="body3" color={error ? 'error' : 'grey-dark'} className="pt-1">
            {message}
        </Typography>
    );
};

const InputLabel = ({ label }) => {
    return (
        <Typography variant="body3" color="grey-normal" className="pb-1">
            {label}
        </Typography>
    );
};

const ActualInput = forwardRef(({ className, search, disabled, error, ...rest }, ref) => {
    return (
        <input
            autoComplete="false"
            disabled={disabled}
            className={`transition-all text-16/20 text-grey-dark active:text-black disabled:text-grey-normal placeholder-grey-normal py-3.5 ${
                search ? 'pl-10 pr-6' : 'py-3 px-6'
            } bg-white disabled:bg-grey-light border ${
                error
                    ? 'border-error'
                    : `border-grey-normal hover:border-brand-light ${
                          !disabled && 'active:border-brand-light' // Lord forgive me for these disgusting ternaries 😩🙏
                      }`
            } disabled:border-grey-light rounded-lg outline-none ${className}`} // focus:ring focus:border-blue-light active:ring
            ref={ref}
            {...rest}
        />
    );
});

export const Input = forwardRef(
    ({ className = '', type = 'input', error = false, label, message, ...rest }, ref) => {
        if (type === 'search')
            return (
                <div className={`flex flex-col`}>
                    {label && <InputLabel label={label} />}
                    <div className="relative">
                        <ActualInput className={className} search={true} {...rest} />
                        <div className="text-black absolute h-full flex items-center left-4 top-0 transition-all">
                            <IconComponent icon="search" width={16} height={16} />
                        </div>
                    </div>
                    {message && <InputMessage error={error} message={message} />}
                </div>
            );

        return (
            <div className="flex flex-col">
                {label && <InputLabel label={label} />}
                <ActualInput
                    className={className}
                    search={false}
                    error={error}
                    ref={ref}
                    {...rest}
                />
                {message && <InputMessage error={error} message={message} />}
            </div>
        );
    }
);
